import type { FaireProductEntity } from "../../entity_types/product";

export const p_sm4vtkuaq7: FaireProductEntity = {
  token: "p_sm4vtkuaq7",
  type: "product",
  name: "Anti-Itch Balm | Menthol & Colloidal | 1 Pack - 18g",
  brandToken: "b_hhg6www3ax",
  brandName: "Luna Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/d00e37f014fcba54fc01a82a1d534c5540cfe4594e9836cb5be1f9fe8718dc11.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f160b01b9437d52b99758bd4d9e9f2c165042f4d4e054e4dcb7e8a2ed3b10ab.png",
    "https://cdn.faire.com/fastly/e859fc6a457aca3e127e865d543d72207aa599f674882d51fbe585729461e972.png",
    "https://cdn.faire.com/fastly/1de9c771a14e7c89b2710adfa794e13fb59c57a68702ad774af16fb5ea8236f3.png",
  ],
  priceDollars: 5,
  description:
    "Luna Naturals Anti-Itch Balm – Spring & Summer Relief for Bug Bites, Rashes & Sensitive Skin\n\nEnjoy the outdoors itch-free this spring with Luna Naturals Anti-Itch Balm, a fast-acting, soothing solution for itchy, irritated skin. Perfect for warmer weather, this gentle balm cools and calms skin affected by bug bites, pollen irritation, rashes, dry patches, and sun exposure. Powered by menthol and colloidal oatmeal, it delivers instant relief while nourishing and protecting sensitive skin.\n\nWhy You’ll Love It This Spring:\n\n• Instant Cooling Relief – Menthol provides fast-acting itch relief, ideal after outdoor activities, hikes, gardening, or playground time.\n• Soothes Seasonal Skin Irritation – Colloidal oatmeal helps calm redness, dryness, and irritation caused by spring allergens and changing weather.\n• Lightweight & Non-Greasy – Smooth balm absorbs quickly without sticky residue, perfect for everyday use on the go.\n• Gentle for All Ages – Safe for kids and adults with sensitive skin, made without harsh chemicals.\n• Spring & Summer Essential – Ideal for bug bites, rashes, eczema flare-ups, sunburn, and minor skin irritations.\n\nBe prepared for every outdoor moment—keep Luna Naturals Anti-Itch Balm on hand for fast, natural relief all season long.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:32.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
